import styled, { createGlobalStyle } from 'styled-components';
//import React from 'react';


const tlRodWidth = 6;
const tlThumbOuterDia = 16;
const tlThumbInnerDia = 10;


const tlColor = 'rgb(21, 203, 178)';
const tlBorderColor = 'rgb(240, 240, 240)';

const tlThumbBackgroundColor = 'rgb(255, 255, 255)';
const tlThumbColor = 'rgb(21, 203, 178)';

const TimelineLegendConstants = {
    Color:tlColor,
    BorderColor:tlBorderColor,

    RodWidth:tlRodWidth,

    ThumbOuterDia:tlThumbOuterDia,
    ThumbInnerDia:tlThumbInnerDia,

    ThumbBackgroundColor:tlThumbBackgroundColor,
    ThumbColor:tlThumbColor,
};


const TimelineLegendContainer = styled.div`
  position:relative;
  height:100%;
  width:100%;
`;

const TimelineLegendUpperLabelLeft = styled.div`
  position:absolute;
  top:0;
  left:0;
  height:16px;
  color: rgb(64,64,64);
`;

const TimelineLegendUpperLabelRight = styled.div`
  position:absolute;
  top:0;
  right:0;
  height:16px;
  color: rgb(64,64,64);
`;

const TimelineLegendLowerLabel = styled.div`
  position:absolute;
  top:0;
  left:0;
  height:16px;
  color: rgb(64,64,64);
`;


export {
    TimelineLegendContainer,
    TimelineLegendUpperLabelLeft,
    TimelineLegendUpperLabelRight,
    TimelineLegendLowerLabel,

    TimelineLegendConstants,
};